module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48dGl0bGU+Q2xvc2U8L3RpdGxlPjxwYXRoIGQ9Ik04LjgxOCAxMkwuNjU4IDMuODRBMi4yNSAyLjI1IDAgMCAxIDMuODQyLjY2TDEyIDguODE3bDguMTYtOC4xNmEyLjI1IDIuMjUgMCAwIDEgMy4xOCAzLjE4M0wxNS4xODMgMTJsOC4xNiA4LjE2YTIuMjUgMi4yNSAwIDAgMS0zLjE4MyAzLjE4TDEyIDE1LjE4M2wtOC4xNiA4LjE2YTIuMjUgMi4yNSAwIDAgMS0zLjE4LTMuMTgzTDguODE3IDEyeiIgZmlsbD0iIzAwMCIgb3BhY2l0eT0iLjIiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/times-icon-gray.svg
// module id = S03J
// module chunks = 89